import {
  ColorTokens,
  getTokenValue,
  SizeTokens,
  Token,
  View,
  ViewProps,
} from "tamagui";
import { hexToRGBA } from "tamagui-config";

export interface GlowCircleProps extends ViewProps {
  size?: SizeTokens;
  color?: ColorTokens;
  opacity?: number;
  gradientSize?: string;
  gradientOrigin?: string;
}
export const GlowCircle = ({
  size = "100%",
  color = "$hgPrimary",
  opacity = 0.3,
  gradientSize = "64.2% 64.2%",
  gradientOrigin = "50% 0%",
  children,
  ...rest
}: GlowCircleProps) => {
  const isHex = typeof color === "string" && color.startsWith("#");
  const hexColor = isHex ? color : getTokenValue(color as Token, "color");
  const safeHexColor =
    typeof hexColor === "string" && hexColor.startsWith("#")
      ? hexColor
      : "#3C984C";
  const rgbaColor = hexToRGBA(safeHexColor, opacity);
  const cssGradient = `radial-gradient(${gradientSize} at ${gradientOrigin}, ${rgbaColor} 0%, transparent 100%)`;
  return (
    <View width={size} height={size} background={cssGradient} {...rest}>
      {children}
    </View>
  );
};
